import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center py-8" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      innerHTML: _ctx.RANDOM_SHAPES_ICON,
      class: "text-primary-purple w-10 h-10"
    }, null, 8, _hoisted_2),
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-black text-xxl font-semibold leading-9 text-left" }, "Create New Booking System Layouts", -1)),
    _createVNode(_component_BaseButton, {
      type: "button",
      class: "bg-primary-purple max-w-max px-8 text-white p-2 rounded-md font-inter text-base font-medium leading-6",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createNew')))
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(" Create ")
      ])),
      _: 1
    })
  ]))
}